<template>
  <div class="editorField">
    <el-row customStyle="margin-bottom: 8px">
      <!--输入框-->
      <el-col :span="siz">
        <div class="staticField" v-if="typeof fieldValue != 'object'">
          <component :type="InputType" :is="component" v-model="fieldValue" @change="handleChange" @blur="blur" :selectList="selectList" :radioList="radioList" :disabled="able"></component>
        </div>
        <!--如果从编辑框传来的value是对象,说明绑定过变量了,展示绑定的变量名-->
        <div class="dynamicField" v-else>
          {{fieldValue.varName}}
        </div>
      </el-col>
      <el-col v-if='showEditButton' :span="3" class="editorFieldBtnList">
        <el-button class="editorFieldBtn" type="primary" size="mini" :disabled="varList.length === 0" @click="handleEditClick" icon="el-icon-edit">
        </el-button>
        <!--只有绑定了变量,这个解除按钮才能生效-->
        <el-button class="editorFieldBtn" type="danger" size="mini" icon="el-icon-close" :disabled="typeof fieldValue != 'object'" @click="handleCancelBindClick">
        </el-button>
      </el-col>
    </el-row>

    <!--使用show.sync传参，当子组件想要将父组件的这个参数修改时，就只需要emit(update:show,修改的内容)即可,就可以省略父组件的回调了-->
    <var-binding-dialog :component="component" :var-list="varList" :show.sync="show" v-model="fieldValue" :selectList="selectList" :radioList="radioList" :label="label"></var-binding-dialog>
  </div>
</template>

<script>
import VarBindingDialog from "./VarBindingDialog";
import SelectComponent from "./SelectComponent";
import RadioComponent from "./RadioComponent"
import ColorPickerComponent from "./ColorPickerComponent"

// 可以写内容和绑定变量的输入框
export default {
  name: "EditorField",
  props: {
    value: {},
    selectList: Array,
    radioList: Array,
    type: String,
    varList: Array,
    varJson: Object,
    InputType: String,
    showEditButton: Boolean,
    label: String,
    able:{
      type: Boolean,
      default:false
    },
    //标记是否是层级的输入框
    index:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      show: false,
      siz: 8,
      fieldValue: "0"
    }
  },
  components: {VarBindingDialog,SelectComponent,RadioComponent,ColorPickerComponent},
  mounted() {
    if (!this.showEditButton) this.siz = 12      //如果不能绑定变量,会被整合到一起,输入框的siz变大
    this.fieldValue = this.value
  },
  methods: {
    handleChange(val) {
      //console.log("editorField ", val)
      this.$emit('change', val)
    },
    handleEditClick() {
      console.log("handleEditClick")
      this.show = true
    },
    handleCancelBindClick() {
      this.fieldValue = ''
    },
    blur() {    // 失去焦点更新输入框的值
      if(this.type === 'input'){ //层级不允许输入负数
        if(this.index){
          const regex = /^\s*$/;
          const startsWithMinus = /^-/

          if(regex.test(this.fieldValue)||startsWithMinus.test(this.fieldValue)){
            this.fieldValue = '10'
          }
        }
      }
      this.$emit("input", this.fieldValue)
    }
  },
  computed: {
    // 根据属性类型的不同,展示出不同的输入框
    component() {
      if(this.type === 'input') {
        return "el-input";
      }
      else if(this.type === 'switch'){
        return "el-switch";
      }
      else if(this.type === 'select'){
        return "select-component"
      }
      else if(this.type === 'radio'){
        return "radio-component"
      }
      else if(this.type === 'color'){
        return "color-picker-component"
      }
      return null
    },
  },
  watch: {
    fieldValue(val) {
      if (val === this.value) return     // 如果是传来的值导致改变,就不用再更新了
      //console.log("fieldValue改变了",this.fieldValue.varName)

      if (this.type !== "input" || this.fieldValue.varName !== undefined) {   // 只有input输入值时不用
        //console.log("执行修改逻辑")
        this.$emit("input",val)
      }
    },
    value(val) {
      this.fieldValue = val;
    }
  },

}
</script>

<style lang="less" scoped>
  .editorField {
    width: 100%;
    .editorFieldSelect {
      height: 30px;
      line-height: 30px;
      width: 100%;
      border-radius: 5px;
      padding: 0 10px;
    }
    .editorFieldBtnList {
      display: flex;
      justify-content: space-around;
      margin-left: 30px;
      .editorFieldBtn {
        padding: 10px;
        margin-left: 10px;
        height: 35px;
      }
    }
  }
</style>